import axios from "axios";
import gamebox from "../../router/gamebox";
import country_list from "../../locales/country_list.json";
import $ from "jquery";

const host = window.location.host;
const parts = host.split(".");
const currentDate = new Date();
const lang = window.navigator.userLanguage || window.navigator.language;
const language = lang.substring( 0, 2 ); 
let brwlang = localStorage.getItem("lang_gamebox");

if(language =='ms'){
  brwlang ='malay';
}else if(language =='ar'){
  brwlang ='arabic';
}else if(language =='el'){
  brwlang ='greek';
}else if(language =='bg' || parts[0] =='bg'){
  brwlang ='bulgarian';
}else if(language =='no' || parts[0] =='no'){
  brwlang ='norwegian';
}else if(language =='id'){
  brwlang ='indonesian';
}else if(language =='th'){
  brwlang ='thai';
}else if(language =='cs' || parts[0] =='cz'){
  brwlang ='czech';
}else if(language =='en'){
  brwlang ='english';
}

// setInterval(function(){ let d=new Date();console.log(d.getTime()); }, 500);

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

let res = Number(parts[1]);
let type = Number.isInteger(res);
let gcid = "";

if (type == true) {
  gcid = parts[1];
} else {
  gcid = "";
}

const namespaced = true;
const state = {
  live: `http://cook.grabmobi.com`,
  local: `http://[::1]/PuretechGlobalContentPortal`,
  proxyurl: `http://api.allorigins.win/get?url=`,
  //allsubcategory
  allsubcategory_gamebox: {},
  //auth
  auth_gamebox: "",
  //main.vue
  hotpicksCategory_gamebox: {},
  hotpicksData_gamebox: {},
  popular_gamebox: {},
  //hotpicks.vue
  pageHP_gamebox: {},
  //popular.vue
  pagePop_gamebox: {},
  //notification.vue
  notification_gamebox: {},
  main_cover_gamebox: {},
  //icon
  hotpickIcon_gamebox: require(`../../assets/gamebox/imgs/other/Hot Picks.svg`),
  popularIcon_gamebox: require(`../../assets/gamebox/imgs/other/Populars.svg`),
  langButton_gamebox: ``,
  country_gamebox: parts[0],
  host_gamebox: host,
  // lang_gamebox: localStorage.getItem("lang_gamebox"),
  lang_gamebox: brwlang,
  type: "browse",
  gcid_gamebox: gcid,
  hpisLoad_gamebox: false,
  renew_date_gamebox: "",
  subscription_date_gamebox: "",
  msisdn_gamebox: "",
  country_name_gamebox: "",
  gateway_gamebox: "",
  is_unsub: "0"
};

const getters = {
  langButton_gamebox: state => state.langButton_gamebox,
  lang_gamebox: state => state.lang_gamebox,
  gcid_gamebox: state => state.gcid_gamebox,
  country_gamebox: state => state.country_gamebox,
  pageHotPicks_gamebox: state => state.pageHP_gamebox,
  pagePopular_gamebox: state => state.pagePop_gamebox,
  HotPickIcon_gamebox: state => state.hotpickIcon_gamebox,
  PopularIcon_gamebox: state => state.popularIcon_gamebox,
  notification_gamebox: state => state.notification_gamebox,
  main_cover_gamebox: state => state.main_cover_gamebox,
  host_gamebox: state => state.host_gamebox,
  auth_gamebox: state => state.auth_gamebox,
  hpisLoad_gamebox: state => state.hpisLoad_gamebox,
  renew_date_gamebox: state => state.renew_date_gamebox,
  subscription_date_gamebox: state => state.subscription_date_gamebox,
  msisdn_gamebox: state => state.msisdn_gamebox,
  country_name_gamebox: state => state.country_name_gamebox,
  gateway_gamebox: state => state.gateway_gamebox,
  is_unsub_gamebox: state => state.is_unsub
};

const actions = {
  async fetchLocale_gamebox({ commit }, lang) {
    for (let [key, value] of Object.entries(country_list)) {
      if (lang == value.language) {
        lang = value.language;
      } else {
        //english
        lang = lang;
      }
    }

    commit("setLanguage", lang);
  },
  async fetchTranslateButton_gamebox({ commit }, country) {
    for (let [key, value] of Object.entries(country_list)) {
      if (country == key) {
        let button = `<span lang="${value.language}" >
        <img class="flag" lang="${value.language}" src="${value.flag_squareCurved}" />
        <span lang="${value.language}">${value.button_text}</span>
        </span>`;

        commit("setButton", button);
      }
    }
  },
  async fetchAllSubcategory_gamebox({ commit }, subcategory) {
    //to get the subcategory translation
    let subcateg = await axios.get(
      `${state.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=${subcategory}&limit=1&offset=0&domain=${host}`
    );

    commit("setAllSubcategory", subcateg.data.data);
  },
  async fetchPageHotPicks_gamebox({ commit }, file) {
    let data = file[0];

    let limit = 0;

    if (file[1] != undefined) {
      limit = parseInt(
        file[1].target.options[file[1].target.options.selectedIndex].value
      );
    } else {
      //default
      limit = 200;
    }

    let response = [];
    if (data == undefined) {
      response = await axios.get(
        `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=${limit}&offset=0&domain=${host}`
      );
    } else {
      response = await axios.get(
        `${state.live}/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=${data}&limit=${limit}&offset=0&domain=${host}`
      );
    }

    response.data.data.sort((a, b) =>
      a.cont_name_english.localeCompare(b.cont_name_english)
    );

    commit("setPageHotPicks", response.data.data);
  },
  async fetchPagePopular_gamebox({ commit }, e) {
    let limit = 0;

    if (e != undefined) {
      limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let url = `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=${limit}&offset=0&domain=${host}`;
    let response = await axios.get(url);

    let data = response.data.data;

    data.sort(function(a, b) {
      //to sort random
      return b.rating - a.rating;
    });
    commit("setPagePopular", data);
  },
  async getDomain_gamebox({ commit }, host) {
    let response = await axios.get(
      `${state.live}/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6`
    );

    let dom = response.data.data;
    dom = dom.filter(item => {
      return item.domain == host;
    });

    let domain = "";

    if (dom != "") {
      domain = dom[0].is_unsub;

      if (dom[0].gateway_id != "0") commit("setGatewayID", dom[0].gateway_id);
    } else {
      domain = "0";
    }

    commit("setUnsubButton", domain);
  },
  async fetchToken_gamebox({ commit, dispatch }, id) {
    let auth = "";
    let check = "";

    let token = localStorage.getItem("userToken_gamebox");
    let userProfile = localStorage.getItem("userProfile_gamebox");

    let str = window.location.pathname;
    let path = str.split("/");
    path.pop();
    path = path.join("/");

    if (path == "") {
      path = "/home";
    }

    if (token != null) {
      //checking if have token
      auth = token;
    } else {
      //checking if have param id
      auth = id;
    }

    if (auth != undefined) {
      //to check if token has numbers and letters
      // check = dispatch("checkToken_gamebox", auth);
      // console.log(check)
      auth = auth.toLowerCase();
      var letterNumber = "^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$";
      if (auth.match(letterNumber)) {
        check = true;
      } else {
        check = false;
      }
    } else {
      if(path !='/detail'){
        gamebox.push({ name: "Login" }).catch(err => {});
      }
    }
    
    if (check == true) {
      //if check is true
      let data = {
        code: auth,
        verbose: "1"
      };

      if (token != null) {
        localStorage.setItem("userToken_gamebox", data.code);
        commit("setUserProfile", JSON.parse(userProfile));
        commit("setAuth", "loggedin");
        // EventBus.$emit("logged-in", "loggedin");
      } else {
        let responses = await axios.post(
          `${state.proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?code=${data.code}&verbose=${data.verbose}`)
        );
        var response = JSON.parse(responses.data.contents);

        if (response.status == "active") {
          localStorage.setItem("userToken_gamebox", data.code);
          localStorage.setItem("userProfile_gamebox", responses.data.contents);
          commit("setUserProfile", response);
          commit("setAuth", "loggedin");

          gamebox.push({ path: path }).catch(err => {});
          // location.reload();
        } else if (response.status == "inactive") {
          if (data.code != undefined) {
            alert(response.status.toUpperCase());
          }
          gamebox.push({ name: "Login" }).catch(err => {});
        }
      }
    } else {
      //if check is false
      if(path !='/detail'){
        gamebox.push({ name: "Login" }).catch(err => {});
      }
      
    }
  },
  async checkToken_gamebox({ commit }, auth) {
    var letterNumber = /^[A-Za-z0-9][A-Za-z0-9 ]\*[A-Za-z0-9]\*$/;
    if (auth.match(letterNumber)) {
      return true;
    } else {
      return false;
    }
  },
  async subContent_gamebox({ commit }, file) {
    let token = localStorage.getItem("userToken_gamebox");
    let lang = localStorage.getItem("lang_gamebox");
    let alert_pop = "";

    let alert_lang = require(`../../locales/gamebox/${lang}.json`);
    alert_pop = alert_lang.not_subs;

    if (token != null) {
      if (file[1] != "application/x-zip-compressed") {
        axios.post(`${state.live}/api/newcontents_statistic`, {
          token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
          country: state.country_gamebox,
          product: 'gamebox',
          content_id: file[2],
          type: "download"
        })
        window.location.href = file[0];
        // window.open(file[0], "download");
      } else {
        axios.post(`${state.live}/api/newcontents_statistic`, {
          token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
          country: state.country_gamebox,
          product: 'gamebox',
          content_id: file[2],
          type: "play"
        })

        window.open(file[0], "_blank");
      }
    } else {
      alert(alert_pop);

      setTimeout(() => {
        $("#contentModal").modal("hide");
        gamebox.push({ name: "Login" }).catch(err => {});
      }, 1000);
    }
  },
  async login_gamebox({ commit }, loginAuth) {
    commit("setAuth", loginAuth);
  },
  async fetchNotification_gamebox({ commit }) {
    let notify = [];
    let main_cover = [];
    let date = currentDate.getUTCDate();
    let w = week % 2;

    if (w != 0) {
      date = date + 10;
    }

    let url = `${state.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=10&offset=${date}&domain=${host}`;
    
    let res = await axios.get(url);
    let data = res.data.data.slice(0, 10);

    let noti = data.map(noti => {
      let sub_trans = JSON.parse(noti.subcategory_translate);
      // console.log(noti.created_time)
      let trans_len = Object.keys(sub_trans).length;
      let trans_arr = Object.keys(sub_trans);

      noti.titleSub_english = noti.subcategory;
      if (sub_trans != null || sub_icon != null) {
        for (let i = 0; i < trans_len; i++) {
          noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
        }
      }

      return noti;
    });

    if (w == 0) {
      //name ascending
      noti.sort((a, b) =>
        a.cont_name_english.localeCompare(b.cont_name_english)
      );
    } else {
      //name descending
      noti.sort((a, b) =>
        b.cont_name_english.localeCompare(a.cont_name_english)
      );
    }
    notify = noti.slice(0, 5);
    // main_cover = noti.slice(0, 5);
    (noti.length > 5) ? main_cover = noti.slice(6, 9) : main_cover = noti.slice(0, 5);
    
    commit("setNotification", { notify: notify, main_cover: main_cover });
  },
  async logout_gamebox({ commit }, is_unsub) {
    if (is_unsub != "0") {
      let token = localStorage.getItem("userToken_gamebox");
      let responses = await axios.post(`${state.proxyurl}`+ encodeURIComponent(`http://api.puretechglobal.net/gateway_request/${state.country_name_gamebox}/${state.gateway_gamebox}/unsub.php?code=${token}&msisdn=${state.msisdn_gamebox}`)
      );
      removeStorage();
      console.log(response);
      var response = JSON.parse(responses.data.contents); 
      if (responses.data.contents == 'success' || response.status =='success') {
        location.reload();
      }
      setTimeout(() => {
        location.reload();
      }, 0);
    } else {
      removeStorage();
    }

    function removeStorage() {
      localStorage.removeItem("userProfile_gamebox");
      localStorage.removeItem("userToken_gamebox");
      localStorage.removeItem("logged-in");
    }
  }
};

const mutations = {
  setPageHotPicks: (state, response) => (state.pageHP_gamebox = response),
  setPagePopular: (state, response) => (state.pagePop_gamebox = response),
  setNotification: (state, response) => (
    (state.notification_gamebox = response.notify),
    (state.main_cover_gamebox = response.main_cover)
  ),
  setAuth: (state, response) => (state.auth_gamebox = response),
  setButton: (state, response) => (state.langButton_gamebox = response),
  setLanguage: (state, response) => (state.lang_gamebox = response),
  setUserProfile: (state, response) => (
    (state.renew_date_gamebox = response.next_renew_date),
    (state.subscription_date_gamebox = response.subscription_date),
    (state.msisdn_gamebox = response.msisdn),
    (state.country_name_gamebox = response.country_code),
    (state.gateway_gamebox = response.gateway_code)
  ),
  setGatewayID: (state, response) => (state.gcid_gamebox = response),
  setUnsubButton: (state, response) => (state.is_unsub = response)
};

export default {
  // namespaced,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/gamebox-store.js